function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M281.3 98.3c-5.3-19.5-28.9-24.2-47.8-24.7-13.6-.2-27.2.9-40.7 3.2C152.4 51.9 99.3 64.5 74.4 105c-2.8 4.6-5.2 9.5-7.1 14.5-6.7 3.6-13.1 7.2-19 11C13.7 152.3-1.2 172.8 4 191.6c5.3 19.5 28.9 24.2 47.8 24.7 1.4 0 2.8.1 4.2.1 11.2-.1 22.4-1 33.5-2.8 35 32.3 89.4 30.1 121.7-4.9 12-13 19.7-29.4 22.1-46.9 1.3-.8 2.6-1.6 3.8-2.3 34.4-21.9 49.3-42.5 44.2-61.2zm-133.5-5.8c14.1 0 27.7 5.2 38.2 14.5 11 9.7 17.9 23.3 19.2 37.9-31.5 16.9-70.5 30.7-105 37.8-18-26.3-11.3-62.2 15-80.1 9.6-6.6 20.9-10.1 32.6-10.1zm-95.3 95.3c-13.9-.4-19.2-3-20.9-4.1 1-3.5 7.8-13.7 30.1-28.1.7 11 3.5 21.7 8.2 31.6-5.7.6-11.5.7-17.4.6zm95.3 20.1c-6.2 0-12.3-1-18.1-2.9 22.9-6.2 45.3-14.3 66.9-24-10.6 16.7-29 26.9-48.8 26.9zm83.5-79c-2.4-9.5-6.4-18.5-11.9-26.6 4.7-.3 9.2-.4 13.3-.3 13.9.4 19.2 3 20.9 4.1-.9 3.1-6.2 11.2-22.3 22.8z"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-80.781 240.95 240.965)",
  cx: "240.9",
  cy: "241",
  r: "28.3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "42.5",
  cy: "49.6",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "212.6",
  cy: "28.3",
  r: "21.3"
})));